declare namespace $ {

	type $mol_view__event_shm_projects_image_viewer_1 = $mol_type_enforce<
		({ 
			click( next?: ReturnType< $shm_projects_image_viewer['image_toggle'] > ): ReturnType< $shm_projects_image_viewer['image_toggle'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_shm_projects_image_viewer_2 = $mol_type_enforce<
		ReturnType< $shm_projects_image_viewer['viewer_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_image__uri_shm_projects_image_viewer_3 = $mol_type_enforce<
		ReturnType< $shm_projects_image_viewer['opened_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__loading_shm_projects_image_viewer_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['loading'] >
	>
	type $mol_image__decoding_shm_projects_image_viewer_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['decoding'] >
	>
	type $mol_view__attr_shm_projects_image_viewer_6 = $mol_type_enforce<
		({ 
			'role': string,
			'aria-modal': string,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__event_shm_projects_image_viewer_7 = $mol_type_enforce<
		({ 
			click( next?: ReturnType< $shm_projects_image_viewer['image_close'] > ): ReturnType< $shm_projects_image_viewer['image_close'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_shm_projects_image_viewer_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_image__uri_shm_projects_image_viewer_9 = $mol_type_enforce<
		ReturnType< $shm_projects_image_viewer['uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__loading_shm_projects_image_viewer_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['loading'] >
	>
	type $mol_image__decoding_shm_projects_image_viewer_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['decoding'] >
	>
	export class $shm_projects_image_viewer extends $mol_pop {
		image_escape_listener( ): any
		expanded( ): boolean
		image_toggle( next?: any ): any
		viewer_content( ): readonly(any)[]
		Preview( ): $mol_view
		image_close( next?: any ): any
		Full( ): $mol_image
		Overlay( ): $mol_view
		uri( ): string
		content( ): readonly(any)[]
		opened_uri( next?: string ): string
		auto( ): readonly(any)[]
		attr( ): ({ 
			'expanded': ReturnType< $shm_projects_image_viewer['expanded'] >,
		})  & ReturnType< $mol_pop['attr'] >
		Anchor( ): ReturnType< $shm_projects_image_viewer['Preview'] >
		bubble_content( ): readonly(any)[]
		Preview_image( ): $mol_image
	}
	
}

//# sourceMappingURL=viewer.view.tree.d.ts.map